import { configureStore } from '@reduxjs/toolkit'
import {userSlice} from './slices/userSlice'
import {databaseSlice} from './slices/databaseSlice'

export default configureStore({
  reducer: {
    user: userSlice.reducer,
    database: databaseSlice.reducer,
  },
})
